import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { Button } from '@components/buttons'
import { TextInput } from '@components/inputs'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import { AppDispatch, useSelector } from '@state/store'
import { forgottenPassowrdSchema } from '@utils/schemas'
import { Actions } from '@state/actions'
import { forgottenPassword } from '@state/thunks/authThunk'
import { useNavigate } from 'react-router-dom'
import { AuthCard } from '../../components/cards/AuthCard'
import logo from '@assets/img/logos/ariane-fse.png'

type Values = {
  email: string
}

export default function ForgottenPassword() {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const loading = useSelector(
    ({ loading }) => loading[Actions.FORGOTTEN_PASSWORD],
  )

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({
    resolver: yupResolver(forgottenPassowrdSchema),
  })

  const onSubmit = ({ email }: Values) => {
    dispatch(forgottenPassword({ email })).then(() => navigate('/auth/login'))
  }

  const Content = (
    <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        variant="filled"
        type="email"
        name="email" // {...register('email')}
        label="Email"
        color="primary"
        errors={errors}
        control={control}
        autoFocus
      />
      <Button
        type="submit"
        text="submit"
        textColor="white"
        loading={loading}
        fullWidth
        color="secondary"
        format
      />
    </form>
  )

  return (
    <Box
      sx={{
        backgroundImage: 'linear-gradient(45deg, #303f9f, #7b1fa2)',
        borderRadius: 1,
        padding: 3,
        zIndex: 1,
      }}
    >
      <div className="bg-white mb-4">
        <img src={logo} alt="Ether HealthCare" className="w-full h-20" />
      </div>
      {Content}
      <AuthCard.Actions backToLoginLink />
    </Box>
  )
}
